import { share } from '../../connection';
import { BlobSyncStorageBase } from '../../storage';
import { IDBConnection, type IDBConnectionOptions } from './db';

export class IndexedDBBlobSyncStorage extends BlobSyncStorageBase {
  static readonly identifier = 'IndexedDBBlobSyncStorage';

  readonly connection = share(new IDBConnection(this.options));

  constructor(private readonly options: IDBConnectionOptions) {
    super();
  }

  async setBlobUploadedAt(
    peer: string,
    blobId: string,
    uploadedAt: Date | null
  ): Promise<void> {
    // Sync metadata passes the same account/auth gate as blob payloads.
    await this.connection.encryption.transaction(
      ['blobSync'],
      'readwrite',
      async tx => {
        await tx.objectStore('blobSync').put({
          peer,
          key: blobId,
          uploadedAt,
        });
      }
    );
  }

  async getBlobUploadedAt(peer: string, blobId: string): Promise<Date | null> {
    const record = await this.connection.encryption.transaction(
      ['blobSync'],
      'readonly',
      tx => tx.objectStore('blobSync').get([peer, blobId])
    );
    return record?.uploadedAt ?? null;
  }
}
